<div class="card">
    <div class="card-header">
        <h3 class="mb-0">{{"PROFILE.HELLO"| translate}} {{userName}}</h3>
    </div>
    <div class="card-body p-5 m-auto">
        <button class="btn btn-red"
        (click)="routeToDashboards()">
            {{"PROFILE.OpenDashboard"| translate}}
        </button>
    </div>
</div>